var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.503,
    height: 15.401,
    viewBox: "0 0 13.503 15.401",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1",
    transform: "translate(-0.002 -0.016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6",
    "data-name": "Grupo 6",
    transform: "translate(0.002 0.016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25",
    "data-name": "Trazado 25",
    d: "M6.74,124.548q-2.96,0-5.919,0a.8.8,0,0,1-.645-.363,1.035,1.035,0,0,1-.153-.817c.029-.206.043-.415.077-.621a3.766,3.766,0,0,1,.121-.533,5.547,5.547,0,0,1,.275-.738,7.519,7.519,0,0,1,.5-.885,4.881,4.881,0,0,1,1.5-1.433,5.426,5.426,0,0,1,1.883-.728,8.019,8.019,0,0,1,1.515-.112c.741,0,1.481,0,2.221,0a5.788,5.788,0,0,1,1.97.368,5.174,5.174,0,0,1,2.16,1.534,4.49,4.49,0,0,1,.741,1.167c.112.265.187.545.289.814a5.272,5.272,0,0,1,.227,1.286.932.932,0,0,1-.6,1.024.654.654,0,0,1-.236.036q-2.96,0-5.919,0v0Z",
    transform: "translate(-0.002 -109.149)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_26",
    "data-name": "Trazado 26",
    d: "M45.384,3.845a2.974,2.974,0,0,1-.215,1.348,4.013,4.013,0,0,1-.459.865,3.608,3.608,0,0,1-.934.951,3.719,3.719,0,0,1-1.422.612,3.888,3.888,0,0,1-2.733-.443,3.718,3.718,0,0,1-.865-.684,5.955,5.955,0,0,1-.461-.614,3.3,3.3,0,0,1-.432-.983,4.175,4.175,0,0,1-.108-1.49,3.851,3.851,0,0,1,.182-.8,3.277,3.277,0,0,1,.5-.99A3.639,3.639,0,0,1,39.414.67,3.97,3.97,0,0,1,40.829.086a3.851,3.851,0,0,1,1.728.06,3.669,3.669,0,0,1,1.5.8,3.744,3.744,0,0,1,1,1.317,3.234,3.234,0,0,1,.325,1.588Z",
    transform: "translate(-34.81 -0.016)",
    fill: "#434343"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon-user.7a0fbc4299844d8dbd25dddcf0234664.svg";
export { ForwardRef as ReactComponent };